module.exports = __webpack_public_path__ + "img/header_img2.5b25fa89.png";